import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectors as coreSelectors } from '$data/core';

import {
  selectors as participantsSelectors,
  actions as participantsActions,
} from '$data/participants';

import StudentsPage from './StudentsPage';
import withAnalyticsHoc from '$utils/withAnalyticsHoc';
import { VIEW_STUDENTS_PAGE } from '$variables/analyticsEvents';

const mapStateToProps = (state) => ({
  spaceId: coreSelectors.getCurrentSpaceId(state),
  students: participantsSelectors.getStudents(state),
  isLoading: participantsSelectors.getIsFetchingParticipants(state),
  error: participantsSelectors.getFetchParticipantsError(state),
  viewAs: coreSelectors.getViewAs(state),
});

const mapDispatchToProps = {
  fetchParticipantsInSpace: participantsActions.fetchParticipantsInSpace,
};

const withAnalytics = withAnalyticsHoc({
  eventName: VIEW_STUDENTS_PAGE,
});

const wrap = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAnalytics
);

export default wrap(StudentsPage);
